export default "__VITE_ASSET__96wxRzig__"